"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./common/config");
var interface_utils_1 = require("@uip-alpha/interface-utils");
var interface_assets_1 = require("@uip-alpha/interface-assets");
var matcher_1 = require("./patch/matcher");
var class_1 = require("./assets/class");
var fuzzy_1 = require("./fuzzy");
var file_1 = require("./common/file");
var allFileVersion = {}; // 版本号配置数据
var configUrl = '/assets/config'; // 行政区数据版本号配置文件路径
/**
 * 获取行政区配置文件
 * @param UIP
 */
var getRegionConfigFromStatic = function (UIP) { return __awaiter(void 0, void 0, void 0, function () {
    var region;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!Object.keys(allFileVersion).length) return [3 /*break*/, 2];
                return [4 /*yield*/, UIP.interface.assets.getFileFromStatic(configUrl, 'region.json', 'region_version')];
            case 1:
                region = (_a.sent()) || {};
                allFileVersion = region;
                _a.label = 2;
            case 2: return [2 /*return*/, allFileVersion];
        }
    });
}); };
/**
 * 对比本地缓存文件版本号
 * @param UIP
 * @param localKey
 * @param fileVersion
 */
var checkRegionVersion = function (UIP, localKey, fileVersion) { return __awaiter(void 0, void 0, void 0, function () {
    var localData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, UIP.localStorage.get(localKey)];
            case 1:
                localData = (_a.sent()) || {};
                if (localData.version === fileVersion)
                    return [2 /*return*/, localData.obj];
                return [2 /*return*/, []];
        }
    });
}); };
/**
 * 获取省市区数据，优先级本地缓存》远程接口
 * @param UIP
 */
var getItem = function (UIP) { return function (localKey, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, fileName, _c, defaultVersion, allFileVersion, fileVersion, fileFullName, localData, remoteData;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = config_1.DEFAULT_REGION_CONFIG[localKey] || [], _b = _a[0], fileName = _b === void 0 ? '' : _b, _c = _a[1], defaultVersion = _c === void 0 ? '' : _c;
                    return [4 /*yield*/, getRegionConfigFromStatic(UIP)
                        // 版本号优先级 自定义版本号》远程配置文件版本号》UIP内置默认版本号
                    ];
                case 1:
                    allFileVersion = _d.sent();
                    fileVersion = options.version || allFileVersion[localKey] || defaultVersion;
                    fileFullName = fileName + "-" + fileVersion + ".json";
                    return [4 /*yield*/, checkRegionVersion(UIP, localKey, fileVersion)];
                case 2:
                    localData = _d.sent();
                    if (localData.length)
                        return [2 /*return*/, localData
                            // 远程获取数据，数据不为空更新本地缓存数据及版本号
                        ];
                    return [4 /*yield*/, UIP.interface.assets.getRegionFromAssets(fileFullName, localKey)
                        // console.log('remoteddd', JSON.parse(remoteData))
                    ];
                case 3:
                    remoteData = _d.sent();
                    // console.log('remoteddd', JSON.parse(remoteData))
                    if (remoteData.length) {
                        UIP.localStorage.set(localKey, {
                            obj: remoteData,
                            version: fileVersion
                        });
                    }
                    return [2 /*return*/, remoteData];
            }
        });
    });
}; };
var patch = function (UIP) { return function (fragmentAddress, options) {
    if (options === void 0) { options = new class_1.SearchOps(); }
    return __awaiter(void 0, void 0, void 0, function () {
        var regions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getItem(UIP)(options.regionKey)];
                case 1:
                    regions = _a.sent();
                    return [2 /*return*/, new matcher_1.RegionMatcher(fragmentAddress, regions).matchRegion(options.count)];
            }
        });
    });
}; };
var search = function (UIP) { return function (content, options) {
    if (options === void 0) { options = new class_1.SearchOps(); }
    return __awaiter(void 0, void 0, void 0, function () {
        var regions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getItem(UIP)(options.regionKey)];
                case 1:
                    regions = (_a.sent()) || [];
                    return [2 /*return*/, fuzzy_1.searchRegion(regions, content, options)];
            }
        });
    });
}; };
exports.default = (function (config) { return function (UIP) {
    /** 前置依赖模块检测 */
    if (!interface_utils_1.beforeInit(UIP)('http'))
        return;
    UIP.use(interface_assets_1.default(config));
    configUrl = (config && config.configUrl) || UIP.defaultConfig.configUrl || configUrl;
    UIP.checkModule('interface', 'region');
    UIP.interface.region = {
        getItem: getItem(UIP),
        patch: patch(UIP),
        search: search(UIP),
        FILE: file_1.FILE
    };
}; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-region/dist/index.js
// module id = Ijl7
// module chunks = 1